export default "__VITE_ASSET__BZAhWmk8__"